var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 3.33984C5.75 3.82734 6.05 4.08984 6.575 4.08984C6.8375 4.08984 7.0625 4.01484 7.2125 3.90234C7.3625 3.78984 7.4375 3.60234 7.4375 3.33984C7.4375 3.07734 7.3625 2.92734 7.2125 2.77734C7.0625 2.66484 6.8375 2.58984 6.575 2.58984C6.0125 2.58984 5.75 2.85234 5.75 3.33984Z",
    fill: "#4674B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04086 4.90573C5.92803 5.0509 5.85281 5.23235 5.85281 5.48639V8.75256C5.85281 9.0066 5.92803 9.18805 6.04086 9.33322C6.15368 9.47838 6.34173 9.55096 6.60499 9.55096C6.86826 9.55096 7.0563 9.47838 7.16913 9.33322C7.28196 9.18805 7.35718 9.0066 7.35718 8.75256V5.48639C7.35718 4.94202 7.09391 4.68799 6.60499 4.68799C6.34173 4.68799 6.15368 4.76057 6.04086 4.90573Z",
    fill: "#4674B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C9.8 0 12.5 2.7 12.5 6C12.5 9.3 9.8 12 6.5 12C3.2 12 0.5 9.3 0.5 6C0.5 2.7 3.2 0 6.5 0ZM6.5 10.6875C9.0875 10.6875 11.1875 8.5875 11.1875 6C11.1875 3.4125 9.0875 1.3125 6.5 1.3125C3.9125 1.3125 1.8125 3.4125 1.8125 6C1.8125 8.5875 3.9125 10.6875 6.5 10.6875Z",
    fill: "#4674B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.245b4bdb64dc81b3b8590264ff9e67a6.svg";
export { ForwardRef as ReactComponent };